// Import: Middleware Action & Custom Types
import {
    CLEAN_TRANSFER_SALES,
    CLEAN_TRANSFER_SALES_ERROR,
} from "_models/redux/types";

// Action function
export const transferSalesClean = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_TRANSFER_SALES,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_TRANSFER_SALES_ERROR,
            payload: undefined,
        });
    }
};
